// extracted by mini-css-extract-plugin
export default {"card":"Home_card__FJJZL","image":"Home_image__X9A7t","details":"Home_details__SXWnX","center":"Home_center__uV7dh"};